// New Age Braces (Brand 3 - Cupertino, Dr. Robert Chen). Single office.
// Backend: bondLocations.ts NEW_AGE_CUPERTINO (catalog 03a87b20, Edge loc 2,
// procedure 235). English-only for v1 (large Mandarin base; Mandarin is a fast-follow).
//
// THEME COLORS: refined in Phase 3 from the live site.
import type { BrandConfig } from "./types";

export const newAge: BrandConfig = {
  slug: "new-age",
  brandId: "new_age",
  brandName: "New Age Braces",
  logo: "https://www.newagebraces.com/wp-content/uploads/2025/03/logo.svg",
  phone: "(408) 255-3388",
  phoneHref: "tel:+14082553388",
  theme: { primary: "#3775E8", primaryDark: "#304158" }, // scoured 2026-06-26: site CTA blue + dark slate
  locales: ["en"],
  locations: {
    NEW_AGE_CUPERTINO: {
      id: "NEW_AGE_CUPERTINO",
      name: "Cupertino",
      addressLines: ["20520 Town Center Lane", "Cupertino, CA 95014"],
      mapsUrl: "https://maps.google.com/?q=20520+Town+Center+Lane+Cupertino+CA+95014",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { CUPERTINO: "NEW_AGE_CUPERTINO", NEW_AGE: "NEW_AGE_CUPERTINO" },
  // Native booking restored (2026-07): backend mints the Edge Booking token via
  // the Turnstile/CapSolver public-token path. To revert to the Ortho2 SPA
  // handoff, uncomment the line below:
  // ortho2BookingUrl: "https://edgebooking.ortho2.com/search?catalog=03a87b20-3e3a-4e73-b02b-abb731beea58&code=jmjqla",
};
